import { CENTER } from "../engine/math";

export type CameraLayout = {
  portrait: boolean;
  scale: number;
  origin: { x: number; y: number };
  playRect: { x: number; y: number; width: number; height: number };
};

export function calculateCamera(width: number, height: number): CameraLayout {
  const portrait = height > width;
  const horizontalInset = portrait ? 10 : 14;
  const topInset = portrait ? 106 : 64;
  const bottomInset = portrait ? 174 : 78;
  const playRect = {
    x: horizontalInset,
    y: topInset,
    width: Math.max(1, width - horizontalInset * 2),
    height: Math.max(1, height - topInset - bottomInset)
  };
  const worldSpan = portrait
    ? { width: 720, height: 900 }
    : { width: 920, height: 480 };
  const scale = Math.max(0.24, Math.min(playRect.width / worldSpan.width, playRect.height / worldSpan.height));
  const screenCenter = {
    x: playRect.x + playRect.width / 2,
    y: playRect.y + playRect.height / 2
  };
  return {
    portrait,
    scale,
    playRect,
    origin: {
      x: screenCenter.x - CENTER.x * scale,
      y: screenCenter.y - CENTER.y * scale
    }
  };
}
